var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{attrs:{"width":_vm.sectionWidth}},[_c('div',{staticClass:"image-container"},[_c('prismic-image',{attrs:{"img":_vm.data.primary.image,"alt":_vm.data.primary.image.alt,"w":_vm.imageWidth}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }